import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

/** @typedef {import('../../../app/transformers/ProductTransformer').ReorganizeProductObj} ReorganizeProductObj */

/**
 * @typedef {object} ProductReorganizeItemProps
 * @property {ReorganizeProductObj} product - Produit de la ligne
 * @property {number} index - Index du produit dans la catégorie
 * @property {{[key: number]: string}} categoryNames - Noms des catégories indexés par identifiant
 * @property {boolean} disabled - Si les actions sont désactivées (enregistrement en cours)
 * @property {(product: ReorganizeProductObj, categoryId: number) => void} onRemoveCategory - Suppression d'une catégorie du produit
 */

/**
 * Ligne d'un produit dans le réorganisateur de produits
 * @param {ProductReorganizeItemProps} props
 */
export default function ProductReorganizeItem({ product, index, categoryNames, disabled, onRemoveCategory }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: product.id, disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    position: /** @type {'relative'} */('relative'),
    zIndex: isDragging ? 1 : 'auto',
    opacity: isDragging ? 0.8 : 1
  };

  return (
    <tr className="table__tr" ref={setNodeRef} style={style}>
      <td className="table__td">
        <span className="material-symbols-outlined" style={{ cursor: disabled ? 'not-allowed' : 'grab', touchAction: 'none' }} aria-label={`Déplacer ${ product.name }`} {...attributes} {...listeners}>drag_indicator</span>
      </td>
      <td className="table__td">{index + 1}</td>
      <td className="table__td">
        {product.thumbnail ? <img src={product.thumbnail} alt="" style={{ width: '40px', height: '40px', objectFit: 'cover' }} /> : null}
      </td>
      <td className="table__td">
        <a href={`/_show/product/${ product.id }`}>{product.name}</a>
        {product.reference ? (
          <>
            <br />
            <small>(référence : {product.reference})</small>
          </>
        ) : null}
      </td>
      <td className="table__td">
        {product.state ? <div className="badge badge--success">En ligne</div> : <div className="badge badge--danger">Hors ligne</div>}
      </td>
      <td className="table__td">
        <div className="flexline flexline--align-hz flexline--gap-8">
          {product.categoryIds.map(categoryId => (
            <div key={categoryId} className="badge">
              <span className="badge__label">{categoryNames[categoryId] || `Catégorie #${ categoryId }`}</span>
              <span className="badge__icon badge__icon--action material-symbols-outlined" role="button" aria-label="Retirer la catégorie" aria-disabled={disabled} style={{ cursor: disabled ? 'not-allowed' : 'pointer' }} onClick={() => !disabled && onRemoveCategory(product, categoryId)}>close</span>
            </div>
          ))}
          <a className="btn btn--only-svg" href={`/_add/product-tocategory?productId=${ product.id }`} data-tooltip="Ajouter une catégorie"><span className="material-icons">add</span></a>
        </div>
      </td>
    </tr>
  );
}
